export default function formatAvatarString(name: string): string {
  let avatarString = name.replaceAll(',', '').replaceAll('.', '').trim();
  if (avatarString.includes(':')) {
    avatarString = avatarString.split(':')[1] != '' ? avatarString.split(':')[1] : avatarString.split(':')[0];
  }
  return avatarString;
}
